import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets scroll position on route change.
 *
 * Needed now that internal navigation uses router <Link> instead of full page
 * reloads: without it, clicking a nav item from halfway down one page lands you
 * halfway down the next one.
 */
function ScrollRestoration() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}

export default ScrollRestoration;
